module.exports = __webpack_public_path__ + "img/xmtjz.dc276293.jpg";